import { Typography } from './Typography';
import { Button } from './Button';
import { Wrapper } from './Wrapper';
import { Wordmark } from './Wordmark';
import { company, navigation } from '../content/site';
import styles from './Footer.module.css';
export function Footer() {
  return (
    <footer className={styles.footer}>
      <div className={styles.background} />
      <div className={styles.cta}>
        <Typography variant="eyebrow" tone="inherit">
          Начнём сотрудничество
        </Typography>
        <Typography as="h2" variant="heading" tone="inverse">
          Уверенность начинается с точных данных.
        </Typography>
        <div className={styles.description}>
          <Typography tone="inherit">
            Расскажите о вашей задаче. Обсудим объём работ, сроки и формат проверки.
          </Typography>
        </div>
        <Wrapper justify="center">
          <Button href="/contact/" variant="light">
            Обсудить проект
          </Button>
          <Button href="/about/" variant="secondary">
            О компании
          </Button>
        </Wrapper>
      </div>
      <div className={styles.inner}>
        <div className={styles.columns}>
          <div className={styles.brand}>
            <Wordmark inverse />
            <Typography variant="small" tone="inherit">
              Независимый аудит и инвентаризация по всему Казахстану.
            </Typography>
          </div>
          <div>
            <Typography variant="small" tone="inverse">
              Навигация
            </Typography>
            <nav aria-label="Навигация в подвале">
              {navigation.map((n) => (
                <a className={styles.link} key={n.href} href={n.href}>
                  <Typography variant="small" tone="inherit">
                    {n.label}
                  </Typography>
                </a>
              ))}
            </nav>
          </div>
          <div className={styles.contact}>
            <Typography variant="small" tone="inverse">
              Контакты
            </Typography>
            <a className={styles.link} href={`mailto:${company.email}`}>
              <Typography variant="small" tone="inherit">
                {company.email}
              </Typography>
            </a>
            <Typography variant="small" tone="inherit">
              {company.address}
            </Typography>
            <a className={styles.link} href="/documents/audit-vector-presentation.pdf" download>
              <Typography variant="small" tone="inherit">
                Скачать презентацию
              </Typography>
            </a>
          </div>
          <div>
            <Typography variant="small" tone="inverse">
              Документы
            </Typography>
            <div className={styles.documents}>
              <Typography
                variant="small"
                tone="inherit"
              >{`Лицензия ${company.license}`}</Typography>
              <Typography
                variant="small"
                tone="inherit"
              >{`Свидетельство СА РК ${company.certificate}`}</Typography>
              <Typography variant="small" tone="inherit">
                Союз аудиторов Казахстана
              </Typography>
            </div>
          </div>
        </div>
        <div className={styles.bottom}>
          <Typography variant="small" tone="inherit">
            © 2022–2026 ТОО «Audit Vector»
          </Typography>
          <Typography variant="small" tone="inherit">
            Астана · Республика Казахстан
          </Typography>
        </div>
      </div>
    </footer>
  );
}
